import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { EmploymentInfo as SectionKey } from 'Consts/Questionnaire';
import DateInput from '../Fields/DateInput';
import BoolInput from '../Fields/BoolInput';
import PhoneInput from '../Fields/PhoneInput';
import TextareaInput from '../Fields/TextareaInput';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import USStateInput from '../Fields/USStateInput';
import { advisorView } from '../../../../Context/ViewContext';

const Employment = props => (
  <Fragment>
    <BoolInput
      {...props}
      name="clientIsEmployed"
      answerKey="clientIsEmployed"
    />
    <TextInput
      placeholder="Employer"
      name="employer"
      answerKey="clientEmployerName"
      requiredView={advisorView}
    />
    <TextInput
      placeholder="Employer address 1"
      name="employerAddress1"
      answerKey="clientEmployerAddress1"
    />
    <TextInput
      placeholder="Employer address 2"
      name="employerAddress2"
      answerKey="clientEmployerAddress2"
    />
    <TextInput
      placeholder="Employer city"
      name="employerCity"
      answerKey="clientEmployerCity"
    />
    <USStateInput
      label="Employer state"
      name="employerState"
      answerKey="clientEmployerState"
    />
    <TextInput
      placeholder="Employer zip"
      name="employerZip"
      answerKey="clientEmployerZip"
    />
    <PhoneInput
      placeholder="Employer office phone"
      name="employerOfficePhone"
      answerKey="clientEmployerOfficePhone"
    />
    <PhoneInput
      placeholder="Employer cell phone"
      name="employerCellPhone"
      answerKey="clientEmployerCellPhone"
    />
    <TextInput
      placeholder="Job title"
      name="jobTitle"
      answerKey="clientJobTitle"
      requiredView={advisorView}
    />
    <DateInput
      placeholder="Date of Hire"
      name="dateOfHire"
      answerKey="clientDateOfHire"
      requiredView={advisorView}
    />
  </Fragment>
);

const EmploymentInfo = ({ isLastSection }) => (
  <Section
    title="Employment Information"
    isLastSection={isLastSection}
    sectionKey={SectionKey}
  >
    <BoolInput
      test="retired"
      label="Are you retired?"
      name="clientIsRetired"
      answerKey="clientIsRetired"
      uncheckedChildren={<Employment label="Are you employed?" />}
      checkedChildren={<Employment label="Do you work in retirement?" />}
    />
    <BoolInput
      label="Are you considering a job change?"
      name="clientIsConsideringJobChange"
      answerKey="clientIsConsideringJobChange"
      checkedChildren={
        <TextareaInput
          placeholder="Details"
          name="consideringJobChangeDetails"
          answerKey="clientConsideringJobChangeDetails"
        />
      }
    />
    <BoolInput
      label="Is it okay to contact you at work?"
      name="clientOkayToContactAtWork"
      answerKey="clientIsOkayToContactAtWork"
    />
  </Section>
);

EmploymentInfo.propTypes = {
  isLastSection: PropTypes.bool,
};

EmploymentInfo.defaultProps = {
  isLastSection: false,
};

export default EmploymentInfo;
